export const AllowedStatusCodes = ['4', '41', '111', '112', '5', '6', '101', '7', '8', '104', '102', '103', '107', '108'];

